import { render, staticRenderFns } from "./Vitae.vue?vue&type=template&id=c5457b14&"
import script from "./Vitae.vue?vue&type=script&lang=js&"
export * from "./Vitae.vue?vue&type=script&lang=js&"
import style0 from "./Vitae.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports